import { render, staticRenderFns } from "./chinaumsRefundStatus.vue?vue&type=template&id=1b44d596&scoped=true"
import script from "./chinaumsRefundStatus.vue?vue&type=script&lang=js"
export * from "./chinaumsRefundStatus.vue?vue&type=script&lang=js"
import style0 from "./chinaumsRefundStatus.vue?vue&type=style&index=0&id=1b44d596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b44d596",
  null
  
)

export default component.exports